<script setup lang="ts">
const { ui = {} } = defineProps<{
  ui?: {
    base?: string
  }
}>()
</script>

<template>
  <div class="grid-container px-8 md:grid md:grid-cols-[var(--ui-grid-container)] md:px-0">
    <div class="flex min-w-8 flex-col items-end justify-center overflow-hidden md:min-w-10">
      <slot name="left" />
    </div>

    <div
      class="mx-auto sm:max-w-[640px] md:col-start-2 md:grid md:max-w-full md:grid-cols-subgrid"
      :class="[ui?.base, $slots.right ? 'md:col-span-2' : 'md:col-span-3']"
    >
      <slot />
    </div>

    <div class="flex min-w-8 flex-col justify-center overflow-hidden md:min-w-10">
      <slot name="right" />
    </div>
  </div>
</template>

<style>
:root {
  --ui-grid-container-width: 1fr 1fr;
  --ui-grid-container: 1fr var(--ui-grid-container-width) 1fr;
}

@media (min-width: 640px) {
  :root {
    --ui-grid-container-width: minmax(1px, 320px) minmax(1px, 320px);
  }
}

@media (min-width: 768px) {
  :root {
    --ui-grid-container-width: minmax(1px, 384px) minmax(1px, 384px);
  }
}

@media (min-width: 1024px) {
  :root {
    --ui-grid-container-width: minmax(1px, 512px) minmax(1px, 512px);
  }
}

@media (min-width: 1180px) {
  :root {
    --ui-grid-container-width: minmax(1px, 590px) minmax(1px, 590px);
  }
}
</style>
